import { render, staticRenderFns } from "./loaContract.vue?vue&type=template&id=690256fa&"
import script from "./loaContract.vue?vue&type=script&lang=js&"
export * from "./loaContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports